<p-toast/>

<section class="min-h-screen flex items-center justify-center bg-gradient-to-br from-slate-50 to-slate-100">
  <div class="w-full max-w-md px-4">
    <p-card class="shadow-xl rounded-2xl">
      <ng-template pTemplate="header">
        <div class="flex items-center gap-3 p-4">
          <span class="pi pi-bolt text-xl"></span>
          <h1 class="text-xl font-semibold">Accede a tu cuenta</h1>
        </div>
      </ng-template>

      <form class="space-y-5 mt-2" [formGroup]="form" (ngSubmit)="onSubmit()">
        <div class="space-y-2">
          <p-floatLabel class="mb-2">
            <input
              pInputText
              id="correo"
              type="email"
              formControlName="correo"
              class="w-full"
              autocomplete="email"
              [ngClass]="{ 'p-invalid': showError('correo') }"
            />
            <label for="correo">Correo</label>
          </p-floatLabel>
          <small *ngIf="showError('correo')" class="text-red-600">
            {{ correoError() }}
          </small>
        </div>

        <div class="space-y-2">
          <p-floatLabel class="mb-2 !mt-7">
            <p-password
              inputId="contrasena"
              formControlName="contrasena"
              [feedback]="false"
              [toggleMask]="true"
              [inputStyle]="{ width: '100%' }"
              [style]="{ width: '100%' }"
              autocomplete="current-password"
              [ngClass]="{ 'p-invalid': showError('contrasena') }">
            </p-password>
            <label for="contrasena">Contraseña</label>
          </p-floatLabel>
          <small *ngIf="showError('contrasena')" class="text-red-600">
            La contraseña es obligatoria (mín. 6 caracteres).
          </small>
        </div>

        <p-button
          type="submit"
          label="Entrar"
          styleClass="w-full h-11 rounded-xl"
          [loading]="loading()"
          [disabled]="form.invalid || loading()">
        </p-button>
      </form>

      <ng-template pTemplate="footer">
        <div class="p-4 text-center text-sm text-slate-500">
          ¿Olvidaste tu contraseña?
          <a class="text-primary hover:underline cursor-pointer">Recupérala</a>
        </div>
      </ng-template>
    </p-card>
  </div>
</section>
